module.exports = __webpack_public_path__ + "static/media/jere.91d0e2bc.jpg";